module.exports = __webpack_public_path__ + "static/comparison-mobile-41f375bd2f14e57965d73f72e6ebdee8.svg";